// No-flash theme bootstrap (SD-054 §C.4). A synchronous, side-effect-on-import
// module: resolve the persisted (or system) theme and stamp the root theme
// attribute BEFORE the Vue app mounts, so the first paint is already in the
// correct theme — no light flash then dark repaint for a dark-preferring user.
//
// Reuses ticket 04's framework-free helpers so there is ONE resolve/apply
// implementation shared by the bootstrap and the reactive `useTheme()`
// composable — the two can never disagree. `useTheme()` re-applies the same
// value on mount; the bootstrap is authoritative for first paint.
//
// Must be the FIRST import in main.ts so it executes before mount (and before
// any component style resolves against the theme attribute).

import {
  applyTheme,
  readStoredPreference,
  resolveTheme,
} from './composables/useTheme.js';

const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
applyTheme(resolveTheme(readStoredPreference(), systemPrefersDark));
